import React from 'react';
import TenantManager from './../../components/tenantManager';
import tenants from './tenants';

import './worker.css';

class WorkerPage extends React.Component {
    render() {
        const { match } = this.props;
        if (!match || !match.params || !match.params.client || !match.params.contractor || !match.params.worker) {
            return null;
        }
        return (
            <div className="page">
                <TenantManager
                    {...tenants}
                    clientId={match.params.client}
                    contractorId={match.params.contractor}
                    workerId={match.params.worker}
                    tab={match.params.tab}
                />
            </div>
        );
    }
}

WorkerPage.meta = {
    hide: true,
    locations: ['/worker/']
};

export default WorkerPage;



// WEBPACK FOOTER //
// ./src/pages/worker/index.jsx